import React from 'react';

const WeeklySalesHeader = () => {
  return (
    <div className="mb-6">
      <h1 className="text-2xl font-bold text-gray-900">Weekly Sales Report</h1>
      <p className="text-gray-600 mt-1">Analyze weekly sales performance by SKU, category, and region</p>
    </div>
  );
};

export default WeeklySalesHeader; 
